import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
      <div className="content">
        <p>
          Welcome to Snipeslow Dot Dev Game Servers.
        </p>
      </div>
      <div className="content">
        <p><i>
          A gaming community provided by Snipeslow.
        </i></p>
      </div>
        <img src={logo} className="App-logo" alt="logo" />
      <div className="content">
        <p>
        </p>
      </div>
      <div className="footer">
          <p>Disclaimer: Snipeslow Dot Dev Game Servers is not affiliated with any game developers. Game server availability and performance may vary based on demand and technical limitations.</p>
          <p>Snipeslow Game Servers reserves the right to modify, deny or discontinue services at any time without prior notice.</p>
      </div>
      </header>
    </div>
  );
}

export default App;
